export enum FILE_TYPE {
  PDF = 'pdf',
  DOC = 'doc',
  DOCX = 'docx',
  JPG = 'jpg',
  BMP = 'bmp',
  DIB = 'dib',
  JPE = 'jpe',
  JFIF = 'jfif',
  GIF = 'gif',
  TIF = 'tif',
  TIFF = 'tiff',
  PNG = 'png',
  HEIC = 'heic',
  RAR = 'rar',
  ZIP = 'zip',
  XLSX = 'xlsx',
  XLS = 'xls',
  JPEG = 'jpeg',
  WEBP = 'webp',
  PPTX = 'pptx',
  PPT = 'ppt',
}

export enum ALLOW_FILE_TYPE {
  JPG = '.jpg',
  PNG = '.png',
  PDF = '.pdf',
  DOC = '.doc',
  DOCX = '.docx',
  XLSX = '.xlsx',
  XLS = '.xls',
}

export type TAttachment = {
  file_name: string;
  file_id: string;
};
